module.exports = __webpack_public_path__ + "img/51.5d1013de.jpg";